import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HeaderWrapper from "../../Header/HeaderWrapper";
import TextMainBannerWrapper from "../../TextMainBanners/TextMainBannerWrapper";
import Spinner from "../../Spinner";
import { formatDate } from "../../../Helper/Helper";
import { SendPostRequest } from "../../../http";
import FooterWrapper from "../../Footer/FooterWrapper";

function CarousalTabViewNews() {
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getNewsData();
    window.scrollTo(0, 0);
  }, []);

  const getNewsData = async () => {
    setLoading(true);
    try {
      const response = await SendPostRequest("news/list");
      setNewsData(response?.data || []);
    } catch (error) {
      console.error("Error fetching news:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper-inner">
      <HeaderWrapper />
      <TextMainBannerWrapper Heading="News and Updates" Image="theme-2-banner-news.webp"/>

      {loading ? (
        <div className="d-flex justify-content-center py-5">
          <Spinner />
        </div>
      ) : newsData.length > 0 ? (
        <div
          className="portfolio-section section-bg-img bg-fixed my-5"
        // style={{ backgroundImage: 'url("/assets/images/bg/features-bg.jpg")' }}
        >
          <div className="row portfolio-wrap portfolio-classic-pro" data-animation="fadeInDown">
            {newsData.map((item) => (
              <div
                key={item.id}
                className="portfolio-item portfolio-overlay-wrap col-lg-3 col-md-6 col-sm-12 col-xs-12"
              >
                <div className="portfolio-thumb tabs-home-news-portfolio-thumb relative">
                  <Link to={`/news/detail/${item.slug}`}>
                  <img
                    src={item.image || "images/portfolio/portfolio-motors/e1.jpg"}
                    className="img-fluid"
                    alt={item.title}
                    // style={{ height: "500px", objectFit: "cover", width: "100%" }}
                    style={{ height: "auto",  width: "100%" }}
                  />
                  </Link>
                  <div className="portfolio-wrap mansory-services-mobile-view">
                    <div className="portfolio-details-overlay p-3">
                      <h4 className="mb-2 typo-white tabs-home-news-portfolio-title pr-4">
                        <Link to={`/news/detail/${item.slug}`}>{item.title}</Link>
                      </h4>
                      {item.date && (
                        <small className="typo-white d-block mb-2">
                          {formatDate(item.date)}
                        </small>
                      )}
                      <div className="portfolio-content tabs-home-news-portfolio-content typo-white">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item?.content
                              ? (() => {
                                const plainText = item.content.replace(/<[^>]*>/g, "");
                                return plainText.length > 90
                                  ? plainText.substring(0, 90) + "..."
                                  : plainText;
                              })()
                              : "No content available",
                          }}
                        />

                      </div>
                    </div>
                    <div className="portfolio-icons">
                      <Link to={`/news/detail/${item.slug}`} className="link-icon">
                        <i className="icon-link"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="col-12 text-center my-5 py-5">
          <h4>No Record Available</h4>
        </div>
      )}

      <FooterWrapper />
    </div>
  );
}

export default CarousalTabViewNews;